module.exports = function getResource(label, vars = []) {
    let resources = {
        accept: 'Accepter',
        termsConditions: 'conditions',
        mustAcceptTermsConditions: 'Vous devez d’abord accepter les conditions.',
        alreadyEnrolledFlash: 'Vous êtes déjà inscrit à Flash.',
        buttonCTAEnrolled: 'Déjà inscrit',
        buttonCTAEnrollNow: 'S’inscrire',
        flashTermsModalTitle: 'Conditions générales de Flash'
    };
    return resources[label];
};
